import { render, staticRenderFns } from "./MenuItemsEdit.vue?vue&type=template&id=07e9cae0"
import script from "./MenuItemsEdit.vue?vue&type=script&lang=js"
export * from "./MenuItemsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports